const ContactInfo = {
  contact_phone: '+966532900988',
  contact_phone2: '+966500519974',
  contact_email: 'info@aldawood.net',
  hr_email: 'hr@aldawood.net',
  office_hours: 'Mon-Sat: 9.00 am - 6.00 pm',
  top_header_address: 'Al Buhairah, Al Khobar 34722',
  address: '7783 King Khalid Rd, Al Buhairah, Al Khobar 34722, Saudi Arabia',
  office_address_line1: '7783 King Khalid Rd, Al Buhairah',
  office_address_line2: 'Al Khobar 34722, Eastern Province, Saudi Arabia',
  office_map_query: 'MS PLAZA, 7783 King Khalid Rd, Al Buhairah, Al Khobar 34722, Saudi Arabia',
    office_maps_share_url:
    'http://google.com/maps/place/MS+PLAZA+%D9%85%D9%83%D8%A7%D8%AA%D8%A8+%D9%84%D9%84%D8%A5%D9%8A%D8%AC%D8%A7%D8%B1%E2%80%AD/@26.2381661,50.1578578,13z/data=!4m10!1m2!2m1!1sms+plaza+al+khobar!3m6!1s0x3e49c3aea2adf115:0xf35f2c9363f532dd!8m2!3d26.1901017!4d50.1876654!15sChJtcyBwbGF6YSBhbCBraG9iYXKSAQ9zaG9wcGluZ19jZW50ZXLgAQA!16s%2Fg%2F11fntbmh40!5m1!1e1?entry=ttu&g_ep=EgoyMDI2MDQyOS4wIKXMDSoASAFQAw%3D%3D',
  office_map_embed_url:
    'https://maps.google.com/maps?q=26.1901017,50.1876654&z=17&ie=UTF8&iwloc=&output=embed',
    office_map_lat: 26.1901017,
    office_map_lng: 50.1876654,
    office_map_zoom: 17,
  facebook: 'https://www.facebook.com/profile.php?id=61586997719438',
  X: 'https://x.com/t61337_quality?s=20',
  instagram: 'https://www.instagram.com/qtechksa2',
  tiktok: 'https://www.tiktok.com/@qualitytechnologies?is_from_webapp=1&sender_device=pc',
  snapchat:
    'https://www.snapchat.com/@quality7946?sender_web_id=13de1da4-e2be-4f5a-9896-24be8a98827e&device_type=desktop&is_copy_url=true',
};

const SERVICE_TESTIMONIALS = [
  {
    quote:
      'Q-Tech delivered our industrial scope on schedule with strong HSE performance and clear communication throughout execution.',
    name: 'Project Director',
    role: 'Energy Sector Client',
    image: 'testimonial/style1/testi1.jpg',
  },
  {
    quote:
      'Their civil and mechanical teams integrated smoothly with our engineering partners and maintained quality across every milestone.',
    name: 'Construction Manager',
    role: 'Industrial Facility',
    image: 'testimonial/style1/testi2.jpg',
  },
  {
    quote:
      'From planning to handover, Q-Tech provided dependable field supervision and responsive support for our Eastern Province project.',
    name: 'Operations Lead',
    role: 'Utilities Client',
    image: 'testimonial/style1/testi3.jpg',
  },
  {
    quote:
      'Professional execution, transparent reporting, and a safety-first culture made Q-Tech a reliable partner on our multi-discipline site.',
    name: 'Site Manager',
    role: 'Industrial Client',
    image: 'testimonial/style1/testi4.jpg',
  },
];

const SERVICES_ITEMS = [
  {
    slug: 'civil-works',
    image: 'services/main-home/main-img/servic-1.jpg',
    icon: 'services/main-home/main-icons/service-icon1.png',
    listIcon: 'services/style12/icons/ser1.png',
    title: 'Civil Works',
    description:
      'Structural and civil engineering works for industrial, commercial, and infrastructure projects across the Kingdom.',
    link: '/services/civil-works',
    subtitle:
      'Structural and civil execution for industrial, commercial, and infrastructure projects across Saudi Arabia.',
    heading: 'Reliable Civil & Structural Delivery',
    intro:
      'Q-Tech Contracting provides end-to-end civil works for facilities, plants, and infrastructure networks. Our teams manage earthworks, foundations, concrete structures, and site development with strict adherence to Saudi standards and client specifications.',
    bullets: [
      'Site preparation, foundations, and reinforced concrete structures',
      'Roads, drainage, and utility corridor civil works',
      'Coordination with mechanical and E&I disciplines on integrated sites',
      'HSE-led execution with documented quality control at every stage',
    ],
    counter1: { value: 120, label: 'Civil projects delivered', icon: 'counter/icons/ser-single/si1.png' },
    counter2: { value: 28, label: 'Years of field experience', icon: 'counter/icons/ser-single/si2.png' },
    closing:
      'Whether supporting greenfield developments or brownfield upgrades, we align civil scope with project milestones and deliver durable structures built for long-term industrial operation.',
    gallery: ['services/services-single/ser1.jpg', 'services/services-single/ser3.jpg'],
  },
  {
    slug: 'electrical-instrument',
    image: 'services/main-home/main-img/servic-2.jpg',
    icon: 'services/main-home/main-icons/service-icon2.png',
    listIcon: 'services/style12/icons/ser2.png',
    title: 'Electrical & Instrument (E&I)',
    description:
      'Electrical systems and instrumentation for oil, gas, energy, and utility sectors with precision and compliance.',
    link: '/services/electrical-instrument',
    subtitle:
      'Electrical and instrumentation systems for oil, gas, energy, and utility operations.',
    heading: 'Precision Electrical & Instrumentation',
    intro:
      'Our E&I division designs, installs, tests, and commissions electrical and instrumentation systems for demanding process environments. We support power distribution, control systems, and field instrumentation with certified technicians and documented commissioning.',
    bullets: [
      'Power distribution, cabling, and panel installation',
      'Instrumentation calibration, loop checks, and commissioning',
      'Integration with DCS, PLC, and safety instrumented systems',
      'Compliance with client specs and Saudi regulatory requirements',
    ],
    counter1: { value: 85, label: 'E&I scopes completed', icon: 'counter/icons/ser-single/si1.png' },
    counter2: { value: 700, label: 'Skilled technicians', icon: 'counter/icons/ser-single/si2.png' },
    closing:
      'From early energization through final performance tests, Q-Tech ensures reliable electrical and instrumentation delivery that keeps facilities safe, efficient, and operational.',
    gallery: ['services/services-single/ser2.jpg', 'services/services-single/ser4.jpg'],
  },
  {
    slug: 'mechanical-work',
    image: 'services/main-home/main-img/servic-3.jpg',
    icon: 'services/main-home/main-icons/service-icon3.png',
    listIcon: 'services/style12/icons/ser3.png',
    title: 'Mechanical Work',
    description:
      'Installation, maintenance, and commissioning of mechanical systems for industrial and process facilities.',
    link: '/services/mechanical-work',
    subtitle:
      'Mechanical installation, maintenance, and commissioning for industrial process facilities.',
    heading: 'Industrial Mechanical Excellence',
    intro:
      'Q-Tech mechanical teams handle equipment setting, piping, rotating machinery, and process tie-ins for refineries, plants, and utility sites. We combine skilled trades with disciplined planning to minimize downtime and protect asset integrity.',
    bullets: [
      'Equipment installation, alignment, and mechanical completion',
      'Process piping, supports, and hydro testing support',
      'Preventive and corrective maintenance for operating plants',
      'Shutdown and turnaround mechanical support',
    ],
    counter1: { value: 95, label: 'Mechanical work packages', icon: 'counter/icons/ser-single/si1.png' },
    counter2: { value: 38, label: 'Active client partnerships', icon: 'counter/icons/ser-single/si2.png' },
    closing:
      'Our mechanical crews work closely with civil and E&I teams to deliver integrated packages that meet schedule, safety, and performance targets on every site.',
    gallery: ['services/main-home/main-img/servic-3.jpg', 'services/services-single/ser3.jpg'],
  },
  {
    slug: 'insulation-work',
    image: 'services/main-home/main-img/servic-4.jpg',
    icon: 'services/main-home/main-icons/service-icon4.png',
    listIcon: 'services/style12/icons/ser4.png',
    title: 'Insulation Work',
    description:
      'Thermal, acoustic, and protective insulation for pipelines, vessels, and process equipment.',
    link: '/services/insulation-work',
    subtitle:
      'Thermal, acoustic, and protective insulation for pipelines, vessels, and equipment.',
    heading: 'Specialized Insulation Solutions',
    intro:
      'We provide hot, cold, and personal protection insulation for pipelines, tanks, vessels, and equipment in oil, gas, and industrial environments. Materials and application methods are selected to maximize energy efficiency and personnel safety.',
    bullets: [
      'Hot and cold insulation for process lines and equipment',
      'Acoustic and fire-protection insulation systems',
      'Cladding, jacketing, and weatherproof finishing',
      'Inspection-ready documentation and quality records',
    ],
    counter1: { value: 60, label: 'Insulation contracts', icon: 'counter/icons/ser-single/si1.png' },
    counter2: { value: 15, label: 'Specialist crews', icon: 'counter/icons/ser-single/si2.png' },
    closing:
      'Proper insulation protects assets, reduces energy loss, and supports safe operations. Q-Tech applies proven methods and materials suited to Saudi Arabia\'s industrial climate.',
    gallery: ['services/main-home/main-img/servic-4.jpg', 'services/services-single/ser4.jpg'],
  },
  {
    slug: 'boiler-combustion',
    image: 'services/main-home/main-img/servic-5.jpg',
    icon: 'services/main-home/main-icons/service-icon5.png',
    listIcon: 'services/style12/icons/ser5.png',
    title: 'Boiler & Combustion',
    description:
      'Boiler systems, combustion equipment, and industrial heating solutions for energy and utility operations.',
    link: '/services/boiler-combustion',
    subtitle:
      'Boiler systems, combustion equipment, and industrial heating for energy and utility sites.',
    heading: 'Boiler & Combustion Systems',
    intro:
      'Q-Tech supports installation, maintenance, and optimization of boiler and combustion systems used in utilities, process plants, and industrial facilities. Our teams focus on safe operation, efficiency, and compliance with manufacturer and client standards.',
    bullets: [
      'Boiler erection, piping, and auxiliary system installation',
      'Combustion equipment setup and performance tuning',
      'Routine maintenance and outage support',
      'Coordination with E&I for controls and safety systems',
    ],
    counter1: { value: 40, label: 'Boiler scopes executed', icon: 'counter/icons/ser-single/si1.png' },
    counter2: { value: 55, label: 'Projects nationwide', icon: 'counter/icons/ser-single/si2.png' },
    closing:
      'Reliable heating and combustion performance is critical to plant uptime. We deliver practical field solutions backed by experienced supervision and quality workmanship.',
    gallery: ['services/main-home/main-img/servic-5.jpg', 'services/services-single/ser2.jpg'],
  },
  {
    slug: 'industrial-construction',
    image: 'services/main-home/main-img/servic-6.jpg',
    icon: 'services/main-home/main-icons/service-icon6.png',
    listIcon: 'services/style12/icons/ser6.png',
    title: 'Industrial Construction',
    description:
      'Building and industrial construction for private, industrial, and government sector projects nationwide.',
    link: '/services/industrial-construction',
    subtitle:
      'Full industrial construction for private, government, and energy sector projects across the Kingdom.',
    heading: 'Complete Industrial Construction',
    intro:
      'As part of Al Dawood Holding Group, Q-Tech delivers turnkey industrial construction combining civil, mechanical, and E&I capabilities. We manage complex multi-discipline sites from mobilization through handover for clients across Saudi Arabia.',
    bullets: [
      'Greenfield and brownfield industrial facility construction',
      'Multi-discipline coordination on integrated project sites',
      'Government, private, and energy sector project experience',
      'Documented QA/QC, HSE, and progress reporting',
    ],
    counter1: { value: 55, label: 'Industrial projects', icon: 'counter/icons/ser-single/si1.png' },
    counter2: { value: 28, label: 'Years serving KSA', icon: 'counter/icons/ser-single/si2.png' },
    closing:
      'From early works to final commissioning support, we provide a single accountable partner for industrial construction that meets the expectations of Saudi Arabia\'s growing infrastructure and energy sectors.',
    gallery: ['services/main-home/main-img/servic-6.jpg', 'services/services-single/ser1.jpg'],
  },
];

const PROJECT_ITEMS = [
  {
    image: 'services/main-home/main-img/servic-1.jpg',
    title: 'Jubail Industrial Civil Infrastructure',
    category: 'Civil Works',
    filters: 'filter1',
    link: '/projects/jubail-civil-infrastructure',
  },
  {
    image: 'services/main-home/main-img/servic-2.jpg',
    title: 'Ras Al-Khair Electrical & Instrumentation',
    category: 'Electrical & Instrument (E&I)',
    filters: 'filter3 filter1',
    link: '/projects/ras-alkhair-electrical-instrumentation',
  },
  {
    image: 'services/main-home/main-img/servic-3.jpg',
    title: 'Yanbu Process Mechanical Piping',
    category: 'Mechanical Work',
    filters: 'filter2 filter4',
    link: '/projects/yanbu-mechanical-piping',
  },
];

const PROJECT_LIST_ITEMS = [
  {
    image: 'services/main-home/main-img/servic-1.jpg',
    title: 'Jubail Industrial Civil Infrastructure',
    category: 'Civil Works',
    link: '/projects/jubail-civil-infrastructure',
  },
  {
    image: 'services/main-home/main-img/servic-2.jpg',
    title: 'Ras Al-Khair Electrical & Instrumentation',
    category: 'Electrical & Instrument (E&I)',
    link: '/projects/ras-alkhair-electrical-instrumentation',
  },
  {
    image: 'services/main-home/main-img/servic-3.jpg',
    title: 'Yanbu Process Mechanical Piping',
    category: 'Mechanical Work',
    link: '/projects/yanbu-mechanical-piping',
  },
];

const BLOG_ITEMS = [
  {
    image: 'blog/style1/1.jpg',
    title: 'We really appreciate content about the construction',
    author: 'Q-Tech',
    date: 'May 26, 2022',
    category: 'Educational',
    excerpt:
      'The brand has responded by partnering with skincare experts on social and web content, providing ingredient deep-dives and re-sharing followers tips and tricks on social media.',
    link: '/blog/details',
  },
  {
    image: 'blog/style1/2.jpg',
    title: 'Best practices construction law on construction',
    author: 'Q-Tech',
    date: 'May 26, 2022',
    category: 'Educational',
    excerpt:
      'The brand has responded by partnering with skincare experts on social and web content, providing ingredient deep-dives and re-sharing followers tips and tricks on social media.',
    link: '/blog/details',
  },
  {
    image: 'blog/style1/3.jpg',
    title: 'Although many people may overlook the need',
    author: 'Q-Tech',
    date: 'May 26, 2022',
    category: 'Educational',
    excerpt:
      'The brand has responded by partnering with skincare experts on social and web content, providing ingredient deep-dives and re-sharing followers tips and tricks on social media.',
    link: '/blog/details',
  },
  {
    image: 'blog/style1/4.jpg',
    title: 'Construction executive holds a very special place',
    author: 'Q-Tech',
    date: 'May 26, 2022',
    category: 'Educational',
    excerpt:
      'The brand has responded by partnering with skincare experts on social and web content, providing ingredient deep-dives and re-sharing followers tips and tricks on social media.',
    link: '/blog/details',
  },
  {
    image: 'blog/style1/5.jpg',
    title: 'This is another massive sites with a ton of information',
    author: 'Q-Tech',
    date: 'May 26, 2022',
    category: 'Educational',
    excerpt:
      'The brand has responded by partnering with skincare experts on social and web content, providing ingredient deep-dives and re-sharing followers tips and tricks on social media.',
    link: '/blog/details',
  },
  {
    image: 'blog/style1/6.jpg',
    title: 'Industrial construction insights from the Eastern Province',
    author: 'Q-Tech',
    date: 'May 26, 2022',
    category: 'Educational',
    excerpt:
      'The brand has responded by partnering with skincare experts on social and web content, providing ingredient deep-dives and re-sharing followers tips and tricks on social media.',
    link: '/blog/details',
  },
];

const COUNTERS = [
  { value: 55, label: 'Projects' },
  { value: 700, label: 'Total Employees' },
  { value: 38, label: 'Clients' },
  { value: 28, label: 'Years of Experience' },
];

const PROJECT_DETAIL = {
  title: 'Al Khobar Industrial Facility',
  subtitle:
    'Industrial construction and mechanical execution delivered across the Eastern Province.',
  sliderImages: [
    'slider/style3/sl1.jpg',
    'slider/style3/sl2.jpg',
    'slider/style3/sl3.jpg',
  ],
  skills: 'Civil Works, E&I, Mechanical',
  client: 'Private & Government Sector',
  completedDate: '2024',
  location: 'Al Khobar, Eastern Province, Saudi Arabia',
  intro:
    'Q-Tech Contracting delivered full-scope industrial construction for this facility, coordinating civil, mechanical, and electrical teams to meet strict safety and quality standards across the Eastern Province.',
  intro2:
    'From site preparation through commissioning support, our crews aligned with client milestones while maintaining compliance with Saudi regulations and international engineering practices.',
  goals: [
    'Execute civil and structural works to specification',
    'Coordinate E&I and mechanical packages on schedule',
    'Maintain HSE standards across all work fronts',
    'Deliver quality inspections and handover documentation',
    'Support commissioning and client operational readiness',
  ],
  goalsSummary:
    'The project required integrated delivery across multiple disciplines with tight coordination between civil, mechanical, and electrical teams on an active industrial site.',
  goalImage: 'project/details/pro-img1.jpg',
  outcomeImage: 'services/services-single/ser1.jpg',
  outcomes: [
    'Completed civil and mechanical scopes on schedule',
    'Integrated E&I installation with zero major safety incidents',
    'Achieved client quality benchmarks at each milestone',
    'Provided as-built documentation and turnover packages',
    'Enabled smooth transition to operations and maintenance teams',
  ],
  outcomeSummary:
    'The facility was delivered ready for operations with documented quality checks, trained site teams, and a clear path for ongoing maintenance across all installed systems.',
};

const CLIENT_LOGOS = [
  {
    name: 'Saudi Aramco',
    logo: 'partner/clients/aramco.png',
    url: 'https://www.aramco.com',
  },
  {
    name: 'SABIC',
    logo: 'partner/clients/sabic.png',
    url: 'https://www.sabic.com',
  },
  {
    name: 'Samsung',
    logo: 'partner/clients/samsung.png',
    url: 'https://www.samsung.com',
  },
  {
    name: "Ma'aden",
    logo: 'partner/clients/maaden.png',
    url: 'https://www.maaden.com.sa',
  },
  {
    name: 'Saudi Electricity Company',
    logo: 'partner/clients/sec.png',
    url: 'https://www.se.com.sa',
  },
  {
    name: 'Petro Rabigh',
    logo: 'partner/clients/petro-rabigh.png',
    url: 'https://www.petrorabigh.com',
  },
  {
    name: 'ACWA Power',
    logo: 'partner/clients/acwa-power.png',
    url: 'https://www.acwapower.com',
  },
  {
    name: 'SLB',
    logo: 'partner/clients/slb.png',
    url: 'https://www.slb.com',
  },
];

const COMPANY_INFO = {
  name: 'Q-Tech Contracting',
  parentGroup: 'Al Dawood Holding Group',
  tagline: 'Quality Technologies Contracting — part of Al Dawood Holding Group',
  sinceYear: 2023,
};

export {
  ContactInfo,
  SERVICES_ITEMS,
  SERVICE_TESTIMONIALS,
  PROJECT_ITEMS,
  PROJECT_LIST_ITEMS,
  BLOG_ITEMS,
  COUNTERS,
  PROJECT_DETAIL,
  CLIENT_LOGOS,
  COMPANY_INFO,
};
